import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetStripeTerminalLocationMutationVariables = Types.Exact<{
  user_id: Types.Scalars['ID'];
}>;


export type GetStripeTerminalLocationMutation = { __typename?: 'Mutation', getStripeTerminalLocation?: { __typename?: 'StripeTerminalLocation', id: string, display_name: string, livemode: boolean, object: string, deleted?: boolean | null, address: { __typename?: 'StripeTerminalLocationAddress', line1: string, city: string, state: string, postal_code: string, country: string } } | null };


export const GetStripeTerminalLocationDocument = gql`
    mutation GetStripeTerminalLocation($user_id: ID!) {
  getStripeTerminalLocation(user_id: $user_id) {
    id
    display_name
    address {
      line1
      city
      state
      postal_code
      country
    }
    livemode
    object
    deleted
  }
}
    `;
export type GetStripeTerminalLocationMutationFn = Apollo.MutationFunction<GetStripeTerminalLocationMutation, GetStripeTerminalLocationMutationVariables>;

/**
 * __useGetStripeTerminalLocationMutation__
 *
 * To run a mutation, you first call `useGetStripeTerminalLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetStripeTerminalLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getStripeTerminalLocationMutation, { data, loading, error }] = useGetStripeTerminalLocationMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useGetStripeTerminalLocationMutation(baseOptions?: Apollo.MutationHookOptions<GetStripeTerminalLocationMutation, GetStripeTerminalLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetStripeTerminalLocationMutation, GetStripeTerminalLocationMutationVariables>(GetStripeTerminalLocationDocument, options);
      }
export type GetStripeTerminalLocationMutationHookResult = ReturnType<typeof useGetStripeTerminalLocationMutation>;
export type GetStripeTerminalLocationMutationResult = Apollo.MutationResult<GetStripeTerminalLocationMutation>;
export type GetStripeTerminalLocationMutationOptions = Apollo.BaseMutationOptions<GetStripeTerminalLocationMutation, GetStripeTerminalLocationMutationVariables>;